// YunUser.js

import React from 'react'
import './YunUser.css';

import YunIcon from '../../Common/YunIcon/YunIcon';

import Avatar from './avatar.png';
import AvatarActive from './avatar-active.png';

import { getToken } from '../../../utils/auth';
import { openWindow, parseTime } from '../../../utils/index';

import Snackbar from '@material-ui/core/Snackbar';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const YunUser = function(props) {
    const { vipInfo, promoteUrl } = props
    const [open, setOpen] = React.useState(false);

    // 展示复制弹框
    function textCopied(text) {
        setOpen(true)
    }
    // 关闭复制弹框
    function closeSnackbar() {
        setOpen(false)
    }

    // 打开原厂充值页（server/empay），商品来自我们后台
    function clickGoPayPage() {
        const base = window.__EM_API_BASE__ || window.location.origin
        openWindow(base + '/empay/?token=' + getToken())
    }
    // 被封禁时唯一的出口
    function clickGoServicePage() {
        openWindow(window.location.origin + window.location.pathname + '#/help')
    }
    // 活动页面
    const handleGoPromote = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        openWindow(promoteUrl + '?token=' + getToken())
    }

    let promoteBtn = null
    if (promoteUrl) {
        promoteBtn = (
            <div className="Btn" onClick={handleGoPromote}>活动</div>
        )
    }

    let userPhoneEle = null;
    if (vipInfo && vipInfo.userPhone) {
        userPhoneEle = (
            <div className="UserInfoItem UserAccount">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="user"></YunIcon>
                </div>
                <div className="UserInfoItemContent">
                    <p>{vipInfo.userPhone}</p>
                    <div className="HandleBtnWrapper">
                        <CopyToClipboard text={vipInfo.userPhone} onCopy={textCopied}>
                            <YunIcon iconClass="Copy" icon="copyIcon"></YunIcon>
                        </CopyToClipboard>
                    </div>
                </div>
            </div>
        )
    }

    let avatarEle = null;
    let userVipEle = null;
    let vipInfoItemEle = null;
    let payBtnEle = null;
    if (vipInfo.banned) {
        // 封禁：只显示手机号 + 账号已被封禁，不显示会员信息，也不给开通入口
        avatarEle = <img className="Avatar" src={Avatar} alt="Avatar" />
        userVipEle = (
            <div className="UserInfoItem UserVip">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="lock"></YunIcon>
                </div>
                <div className="UserInfoItemContent">
                    <p className="BannedText">账号已被封禁</p>
                    <div className="HandleBtnWrapper">
                        {promoteBtn}
                    </div>
                </div>
            </div>
        )
        vipInfoItemEle = (
            <div className="UserInfoItem VipInfoItem">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="user"></YunIcon>
                </div>
                <p className="BannedTip">所有功能已停用，请联系客服解封</p>
            </div>
        )
        payBtnEle = <div onClick={clickGoServicePage} className="Btn PayBtn">联系客服</div>
    } else if (vipInfo.isExpire) {
        avatarEle = <img className="Avatar" src={Avatar} alt="Avatar" />
        userVipEle = (
            <div className="UserInfoItem UserVip">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="vip"></YunIcon>
                </div>
                <div className="UserInfoItemContent">
                    <p>未开通VIP会员</p>
                    <div className="HandleBtnWrapper">
                        {promoteBtn}
                    </div>
                </div>
            </div>
        )
        vipInfoItemEle = (
            <div className="UserInfoItem VipInfoItem">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="freeTimes"></YunIcon>
                </div>
                <p>今日剩余：<span>{vipInfo.tryUseCountToday || 0}首</span></p>
            </div>
        )
        payBtnEle = <div onClick={clickGoPayPage} className="Btn PayBtn">开通会员</div>
    } else {
        avatarEle = <img className="Avatar" src={AvatarActive} alt="Avatar" />
        userVipEle = (
            <div className="UserInfoItem UserVip">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="vip-active"></YunIcon>
                </div>
                <div className="UserInfoItemContent">
                    <p>尊贵的VIP会员</p>
                    <div className="HandleBtnWrapper">
                        {promoteBtn}
                    </div>
                </div>
            </div>
        )
        vipInfoItemEle = (
            <div className="UserInfoItem VipInfoItem">
                <div className="UserInfoItemIcon">
                    <YunIcon icon="expirationTime"></YunIcon>
                </div>
                <p><span>{parseTime(vipInfo.vipExpireTime, '{y}-{m}-{d}')}</span> 到期</p>
            </div>
        )
        payBtnEle = <div onClick={clickGoPayPage} className="Btn PayBtn">续费会员</div>
    }
    return (
        <div className="YunUser">
            <div className="UserInfo">
                {avatarEle}
                {userPhoneEle}
                {userVipEle}
                {vipInfoItemEle}
                <div className="handleBtnWrapper">
                    {payBtnEle}
                </div>
            </div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={open}
                autoHideDuration={1000}
                onClose={closeSnackbar}
                message="复制成功"
            />
        </div>
    )
}

export default YunUser;
